function get_country_venues(country){
  const locations = get_locations();

  if(locations[country]){
    return locations[country].venues;
  }else{
    return [];
  }
}

function get_province_venues(province_id){
  const locations = get_locations();
  let venues = [];

  Object.values(locations).forEach(country => {
    Object.values(country.children || {}).forEach(province => {
      if(province.id == province_id){
        venues = province.venues;
      }
    });
  });

  return venues;
}

function get_locations(only_selectable = false){
  if(!only_selectable){
    return venue_info.locations;
  }else{
    const selectable_locations = {};

    for(const [id, location] of Object.entries(venue_info.locations)){
      const filtered_location = filter_location(location);

      if(location_has_venue(filtered_location)){
        selectable_locations[id] = filtered_location;
      }
    }

    return selectable_locations;
  }
}

function filter_location(location){
  const filtered_location = structuredClone(location);

  if(location.venues?.length){
    const venues = [];

    for(const venue_id of location.venues){
      const venue = get_venue_info(venue_id);

      if(venue.selectable) {
        venues.push(venue_id);
      }
    }

    filtered_location.venues = venues;
  }

  if(location?.children && Object.entries(location.children).length){
    const locations = {};

    for(const [id, current_location] of Object.entries(location.children)){
      const child = structuredClone(current_location);
      const filtered_child = filter_location(child);

      if(location_has_venue(filtered_child)){
        locations[id] = filtered_child;
      }
    }

    filtered_location.children = locations;
  }

  return filtered_location;
}

function location_has_venue(location){
  if(location.venues?.length || location.children?.length){
    return true;
  }else{
    return false;
  }
}

function get_venue(){
  return localStorage.getItem('venue');
}

function get_is_venue_user_selected(){
  return parseInt(localStorage.getItem('venue_is_user_selected') || false, 10);
}

function get_venue_info(id){
  return venue_info.venues[id] || null;
}

function get_current_venue_info(){
  return get_venue_info(get_venue());
}

function get_date_in_timezone(timezone){
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false
  }).formatToParts(new Date());

  const { year, month, day, hour, minute, second } = Object.fromEntries(parts.map(p => [p.type, p.value]));

  return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
}

function get_is_happy_hour_at_venue(venue){
  if(!venue?.timezone) return false;

  const now = get_date_in_timezone(venue.timezone);
  const weekday = now.getUTCDay();
  const hour = String(now.getUTCHours()).padStart(2, '0');
  const minute = String(now.getUTCMinutes()).padStart(2, '0');
  const time = hour + minute;

  const todayHappyHours = venue.happy_hour_times[weekday] || [];

  if(todayHappyHours.length > 0){
    for(happyHour of todayHappyHours){
      if(happyHour.start <= time && happyHour.end >= time){
        return true;
      }
    }
  }

  return false;
}

function get_is_happy_hour_at_current_venue(){
  const venue = get_current_venue_info();
  return get_is_happy_hour_at_venue(venue);
}

function set_venue(venue, user_selected = true){
  localStorage.setItem('venue', venue);
  localStorage.setItem('venue_is_user_selected', +user_selected);

  const event = new CustomEvent('venueChanged', { detail: { venue: venue, user_selected: user_selected } });
  document.body.dispatchEvent(event);
}

function get_user_coordinates(callback) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const coords = {
          lat: position.coords.latitude,
          lon: position.coords.longitude
        };
        callback(coords);
      },
      (error) => {
        callback(null, error);
      }
    );
  } else {
    new Alert("Your browser or device doesn't support geolocation");
  }
}

const haversine = (lat1, lon1, lat2, lon2) => {
  function toRad(x) { return x * Math.PI / 180; }
  const R = 6371; // km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}

function find_closest_venue(coords){
  if (coords == null) return null;

  const locations = get_locations();

  let closest = null;
  let minDistance = Infinity;

  Object.values(locations).forEach(country => {
    Object.values(country.children || {}).forEach(province => {
      Object.values(province.venues || {}).forEach(v => {
        const venue = get_venue_info(v);
        const lat = parseFloat(venue.coordinates?.lat);
        const lon = parseFloat(venue.coordinates?.lon);
        
        if (!isNaN(lat) && !isNaN(lon)) {
          const dist = haversine(coords.lat, coords.lon, lat, lon);
          if (dist < minDistance) {
            minDistance = dist;
            closest = v;
          }
        }
      });
    });
  });

  return closest;
}

function set_venue_by_coordinates(callback){
  get_user_coordinates((coords) => {
    const closest_venue = find_closest_venue(coords);
    
    if(closest_venue){
      set_venue(closest_venue);
    }

    if(callback){
      callback();
    }
  });
}

function find_venue_by_province(user_country, user_province){
  if(!user_country, !user_province) return;

  const locations = get_locations();
  let venue = null;

  Object.values(locations).forEach(country => {
    if(country.name == user_country){
      Object.values(country.children || {}).forEach(province => {
        if(province.name == user_province){
          Object.values(city.venues || {}).forEach(v => {
            if(venue == null || venue.preferred == true){
              venue = v.id;
            }
          });
        }
      });
    }
  });

  return venue;
}

window.get_province_venues = get_province_venues;
window.get_country_venues = get_country_venues;
window.get_locations = get_locations;
window.get_venue = get_venue;
window.get_venue_info = get_venue_info;
window.get_current_venue_info = get_current_venue_info;
window.get_is_happy_hour_at_venue = get_is_happy_hour_at_venue;
window.get_is_happy_hour_at_current_venue = get_is_happy_hour_at_current_venue;
window.set_venue = set_venue;
window.set_venue_by_coordinates = set_venue_by_coordinates;
window.get_is_venue_user_selected = get_is_venue_user_selected;

function auto_set_venue(){
  const noCache = Date.now() + '' + Math.floor(Math.random() * 1000000);

  fetch(geoip.base + '/wp-json/cbm/v1/geoip?nocache=' + noCache)
    .then(response => response.json())
    .then(data => {
      let closest_venue = null;

      if(document.body.classList.contains('single-venue')){
        const match = document.body.className.match(/postid-(\d+)/);
        closest_venue = match[1] || null;
      }else if(data.latitude && data.longitude){
        closest_venue = find_closest_venue({
          lat: data.latitude,
          lon: data.longitude,
        });
      }else if(data.country && data.province){
        closest_venue = find_venue_by_province(data.country, data.province);
      }

      if(closest_venue){
        set_venue(closest_venue, false);
      }else{
        set_venue(Object.keys(venue_info.venues)[0], false);
      }
    })
    .catch(error => {
      console.error(error);
    });
}

function check_current_venue(){
  if(!get_current_venue_info()){
    auto_set_venue();
  }
}

function load_tasks(){
  const url = new URL(window.location.href);
  const url_venue = parseInt(url.searchParams.get('v'));

  if(url_venue && get_venue_info(url_venue)){
    set_venue(url_venue, true);
  }else{
    if(!get_venue()){
      auto_set_venue();
    }else{
      check_current_venue();
    }
  }
}
load_tasks();

function update_with_venue_name(){
  if(get_is_venue_user_selected()){
    const venue = get_current_venue_info();
    document.querySelectorAll('.replace-with-venue-name span').forEach((element) => {
      if(element.childElementCount == 0){
        element.textContent = venue.name;
      }
    });
  }
}
update_with_venue_name();
document.body.addEventListener('venueChanged', update_with_venue_name);